import React, { useState, useEffect, useRef, useCallback } from 'react';
import './FuncionarioCrud.scss';

export default function FuncionarioCrud({ open = false, funcionario = null, onClose = () => {}, onSave = () => {} }) {
  const [form, setForm] = useState({
    nome: '',
    cpf: '',
    telefone: '',
    cargo: '',
    data_admissao: '',
    ativo: true,
    perc_comissao_padrao: 0,
  });
  const overlayRef = useRef(null);
  const firstFieldRef = useRef(null);

  useEffect(() => {
    if (funcionario) setForm(prev => ({ ...prev, ...funcionario }));
    else setForm({ nome: '', cpf: '', telefone: '', cargo: '', data_admissao: '', ativo: true, perc_comissao_padrao: 0 });
  }, [funcionario, open]);

  useEffect(() => { if (open && firstFieldRef.current) firstFieldRef.current.focus(); }, [open]);

  const onKeyDown = useCallback((e) => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => { if (!open) return; window.addEventListener('keydown', onKeyDown); return () => window.removeEventListener('keydown', onKeyDown); }, [open, onKeyDown]);

  if (!open) return null;

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }

  function submit(e) {
    e.preventDefault();
    if (!form.nome || form.nome.trim().length < 2) {
      alert('Informe o nome do funcionário.');
      if (firstFieldRef.current) firstFieldRef.current.focus();
      return;
    }
    const payload = {
      ...form,
      perc_comissao_padrao: Number(form.perc_comissao_padrao || 0)
    };
    onSave(payload);
    onClose();
  }

  function handleOverlay(e) { if (e.target === overlayRef.current) onClose(); }

  return (
    <div className="crud-overlay" ref={overlayRef} onMouseDown={handleOverlay} role="dialog" aria-modal="true">
      <div className="crud-modal" role="document">
        <form onSubmit={submit} className="crud-form">
          <h3>{funcionario ? 'Editar Funcionário' : 'Novo Funcionário'}</h3>
          <div className="form-grid">
            <div className="fg-item">
              <label htmlFor="f-nome">Nome *</label>
              <input id="f-nome" name="nome" ref={firstFieldRef} value={form.nome} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-cpf">CPF</label>
              <input id="f-cpf" name="cpf" value={form.cpf} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-telefone">Telefone</label>
              <input id="f-telefone" name="telefone" value={form.telefone} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-cargo">Cargo</label>
              <input id="f-cargo" name="cargo" value={form.cargo} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-adm">Data Admissão</label>
              <input id="f-adm" type="date" name="data_admissao" value={form.data_admissao} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-ativo">Ativo</label>
              <input id="f-ativo" type="checkbox" name="ativo" checked={form.ativo} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-comissao">% Comissão Padrão</label>
              <input id="f-comissao" name="perc_comissao_padrao" type="number" min="0" max="100" step="0.1" value={form.perc_comissao_padrao} onChange={handleChange} />
            </div>
          </div>
          <div className="crud-actions">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
}
